import React from "react";
import useTranslations from "../Translations/useTranslations";
import "./SidebarCategories.css";
import UiSearch from "../ui/UiSearch";
import { useArticlesGeneriques } from "../Articles/useArticlesGeneriques";
import { ICON } from "../../assets";
import UiIcon from "../ui/UiIcon";
import { useEffect } from "react";

function SidebarCategories({
  items,
  codfag,
  closeModal = () => { },
  selectItem = () => { },
  search_criteria = () => { },
  search_value,
}) {
  const formatTitle = (title) => {
    if (!title) return "";
    return title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
  };
  const trl = useTranslations();
  const [_, articlesGeneriquesMethods] = useArticlesGeneriques();

  function handleSearchCriteriaChange(text) {
    search_criteria(text);
    closeModal();
    articlesGeneriquesMethods.filterCollection(text, ["LIBGEN"]);
  }

  useEffect(() => {
    articlesGeneriquesMethods.filterCollection(search_value, ["LIBGEN"]);
  }, [search_value]);

  function renderCategorieList() {
    if (!items || items?.length === 0) {
      return (
        <div className="category-container"> Aucune catégorie trouvée </div>
      );
    }
    return (
      <React.Fragment>
        {items?.map((fag) => (
          <div
            className="category-container"
            key={fag.CODFAG}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              selectItem(fag);
              closeModal();
            }}
          >
            <UiIcon
              className={`category-icon ${codfag === fag.CODFAG ? "category-selected" : ""
                }`}
              icon={ICON.arrowRightIcon}
              size="md"
            />
            <span
              className={`${codfag === fag.CODFAG ? "category-selected" : ""}`}
            >
              {formatTitle(
                trl.data.message("FAG", "CODFAG", fag.CODFAG, "LIBFAG"),
              )}
            </span>
          </div>
        ))}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="sidebar-categories">
        <div className="sidebar-categories-search">
          <UiSearch
            onSearch={handleSearchCriteriaChange}
            value={search_value}
          />
        </div>
        <div className="sidebar-categories-list">{renderCategorieList()}</div>
      </div>
    </React.Fragment>
  );
}

export default SidebarCategories;
